export const JURISDICTIONS = [
  { id: "ga", name: "Georgia", short: "GA", color: "#FF5D31" },
  { id: "nc", name: "North Carolina", short: "NC", color: "#0B3A2A" },
  { id: "vt", name: "Vermont", short: "VT", color: "#F4A931" },
  { id: "dc", name: "Washington, DC", short: "DC", color: "#8B6914" },
  { id: "national", name: "National", short: "US", color: "#464644" },
];

export const CATEGORIES = {
  crime_incidents: { label: "Crime", color: "#D65C3B" },
  courts: { label: "Courts", color: "#D19C3C" },
  legislation: { label: "Legislation", color: "#0B3A2A" },
  policing: { label: "Policing", color: "#464644" },
  incarceration: { label: "Incarceration", color: "#70706E" },
  reentry: { label: "Reentry", color: "#43695B" },
  campus_crime: { label: "Campus", color: "#002E20" },
  immigration: { label: "Immigration", color: "#FF5D31" },
  homelessness: { label: "Homelessness", color: "#F4A931" },
  other: { label: "Other", color: "#999999" },
};

export const SEARCH_QUERIES = {
  ga: [
    "Georgia criminal justice reform legislation",
    "Atlanta Fulton County court sentencing",
    "Georgia RICO prosecution gang indictment",
    "Georgia prison Department of Corrections",
    "Georgia jail overcrowding deaths",
    "Georgia Board of Pardons and Parole",
    "Atlanta police surveillance technology",
    "Flock Safety Georgia",
    "Georgia pretrial detention bail reform",
    "Georgia criminal trial verdict precedent",
    "Atlanta homelessness criminalization ordinance",
    "DeKalb Gwinnett Cobb County criminal justice",
    "Georgia probation policy",
    "Georgia sentencing disparity",
    "Georgia criminal justice election 2026",
    "AJC criminal justice Georgia",
  ],
  nc: [
    "North Carolina criminal justice reform legislation",
    "Charlotte Mecklenburg County criminal justice",
    "Raleigh Wake County criminal justice",
    "Durham Durham County criminal justice",
    "Greensboro Guilford County criminal justice",
    "Fayetteville Cumberland County criminal justice",
    "Asheville Buncombe County criminal justice",
    "Wilmington New Hanover County criminal justice",
    "North Carolina Iryna's Law",
    "North Carolina ICE immigration enforcement 287g",
    "North Carolina prison Department of Public Safety",
    "North Carolina bail pretrial detention reform",
    "North Carolina public defender indigent defense",
    "North Carolina juvenile justice reform",
    "Durham Department of Community Safety",
    "North Carolina criminal justice election 2026",
    "North Carolina sheriff election 2026",
    "Charlotte Observer criminal justice North Carolina",
  ],
  dc: [
    "Washington DC criminal justice Congress legislation",
    "DC Metropolitan Police MPD staffing hiring",
    "DC Superior Court criminal sentencing",
    "DC criminal code reform council",
    "Congress DC Home Rule crime autonomy",
    "DC violence intervention program",
    "DC jail conditions Central Detention Facility",
    "DC pretrial services CSOSA",
    "DC Public Defender Service",
    "Washington DC police accountability oversight",
    "DC Attorney General prosecution",
    "DC youth crime",
    "DC carjacking",
    "DC juvenile justice",
    "DC Council public safety criminal justice",
    "District of Columbia court sentencing police",
    "DC crime policy 2026",
    "DC Metropolitan Police MPD policy",
  ],
  vt: [
    "Vermont criminal justice reform legislation",
    "Burlington police staffing policy",
    "Vermont prison Department of Corrections",
    "Vermont restorative justice programs",
    "Vermont opioid fentanyl",
    "Vermont drug court",
    "Vermont drug policy",
    "Chittenden County State's Attorney prosecution",
    "Vermont Defender General public defense",
    "Vermont Parole Board policy",
    "Vermont incarceration corrections",
    "Rutland Barre Vermont court sentencing",
    "Vermont sentencing probation reform",
  ],
  national: [
    "sentencing reform",
    "First Step Act",
    "DOJ criminal justice policy",
    "Supreme Court criminal law ruling",
    "federal prison Bureau of Prisons incarceration",
    "policing reform use of force",
    "local police immigration enforcement",
    "federal death penalty execution",
    "drug policy decriminalization",
    "prison reform private prison",
    "criminal justice reform",
    "mass incarceration",
    "district attorney prosecutor election 2026",
    "sheriff election 2026",
    "New York Times criminal justice",
    "Washington Post criminal justice",
    "New Yorker criminal justice",
    "Atlantic criminal justice",
  ],
};

export const LOCAL_OUTLETS = {
  ga: ["wabe.org", "gpb.org", "georgiarecorder.com", "ajc.com"],
  nc: ["wunc.org", "ncnewsline.com", "charlotteobserver.com", "wral.com"],
  dc: ["dcist.com", "washingtoncitypaper.com", "wamu.org", "nbcwashington.com", "wtop.com", "51st.news"],
  vt: ["vtdigger.org", "sevendaysvt.com", "wcax.com"],
  national: [
    "themarshallproject.org", "propublica.org", "newyorker.com",
    "theatlantic.com", "nytimes.com", "washingtonpost.com",
  ],
};

export const ACCENT = "#FF5D31";

export const VALID_JURISDICTIONS = new Set(JURISDICTIONS.map((j) => j.id));
export const VALID_CATEGORIES = new Set(Object.keys(CATEGORIES));
